<template>
    <div class="competence-item">
        <div class="left">
            <router-link
                :to="competenceLink"
                class="name"
                :class="[item.competenceType]"
            >{{ item.name }}</router-link>
            <div
                class="bottom bottom--lg"
            >
                <router-link
                    class="link"
                    :to="competenceLink"
                >Подобрать обучение</router-link>
            </div>
        </div>
        <div class="right">
            <CompetenceItemLevels
                :item="item"
            />
        </div>
        <div
            class="bottom bottom--sm"
        >
            <router-link
                class="link"
                :to="competenceLink"
            >Подобрать обучение</router-link>
        </div>
    </div>
</template>

<script>
import CompetenceItemLevels from './CompetenceItemLevels';
import {mapActions} from 'vuex';

const competencesActions = [
    'addCompetenceToTrack',
];

export default {
    components: {CompetenceItemLevels},
    props: {
        trackId: {
            type: Number,
            default: null,
        },
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        competenceLink() {
            return {
                name: this.item.competenceType === 'hard'
                    ? 'professional-skill'
                    : 'competence',
                params: { id: this.item.id },
            };
        },
    },
    methods: {
        ...mapActions('accountCompetences', competencesActions),

        addToTrack() {
            this.addCompetenceToTrack({
                competenceId: this.item.id,
                trackId: this.trackId,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '~@/styles/rem';
    @import '~@/styles/mrem';

    .competence-item {
        display: flex;

        @include on-mobile {
            flex-direction: column;
        }
    }

    .left {
        width: rem(513);

        @include on-mobile {
            width: 100%;
        }
    }

    .right {
        @include on-mobile {
            margin-top: mrem(16);
            margin-left: mrem(30);
        }
    }

    .name {
        font-family: 'Proxima Nova', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: rem(18);
        line-height: rem(26);
        color: #2A2626;
        display: inline-block;
        padding-left: rem(28);
        min-height: rem(20);

        background-position-x: 0;
        background-position-y: rem(2);
        background-repeat: no-repeat;
        background-size: rem(20);

        @include on-mobile {
            font-size: mrem(18);
            line-height: mrem(26);
            padding-left: mrem(28);
            background-position-y: mrem(2);
            background-size: mrem(20);
        }

        &.soft {
            background-image:  url("~@/assets/images/account-track/icon/competence-soft.svg");
        }
        &.hard {
            background-image:  url("~@/assets/images/account-track/icon/competence-hard.svg");
        }
        &:hover {
            cursor: pointer;
            color: #4663AB;
            background-image:  url("~@/assets/images/account-track/icon/competence-hover.svg");
        }
    }

    .bottom {
        display: none;

        @include on-desktop {
            &--lg {
                margin-left: rem(28);
                margin-top: rem(16);
                display: block;
            }
            .link {
                margin-right: rem(24);
            }
        }

        @include on-mobile {
            &--sm {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                margin-top: mrem(8);
                margin-left: mrem(30);
            }
        }

        .link {
            display: inline-block;
            height: rem(24);
            font-family: 'Proxima Nova', sans-serif;
            font-style: normal;
            font-weight: 600;
            font-size: rem(16);
            line-height: rem(24);
            color: #4663AB;
            padding-bottom: rem(1);
            border-bottom: 1px solid #4663AB;
            cursor: pointer;

            @include on-mobile {
                height: mrem(24);
                font-size: mrem(16);
                line-height: mrem(24);
                padding-bottom: mrem(1);
                margin-top: mrem(8);
            }
        }

        .label {
            display: inline-block;
            height: rem(24);
            font-family: 'Proxima Nova', sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: rem(16);
            line-height: rem(24);
            color: #2A2626;

            &:after {
                display: inline-block;
                margin-left: rem(8);
                content: ' ';
                width: rem(16);
                height: rem(13);
                margin-right: rem(24);
                background: url("~@/assets/images/icons/check-green.svg") no-repeat center/contain;
            }

            @include on-mobile {
                height: mrem(24);
                font-size: mrem(16);
                line-height: mrem(24);

                &:after {
                    margin-left: mrem(8);
                    width: mrem(16);
                    height: mrem(13);
                    margin-right: mrem(24);
                }
            }

        }
    }
</style>